import React from "react";

// reactstrap components
import {
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import OverOnsHeader from "components/Headers/OverOnsHeader.js";
import DarkFooter from "components/Footers/DarkFooter.js";
import SEO from "components/SEO.js";

function OverOns() {
  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });
  return (
    <>
      <SEO 
        title="Jachthondenkennel Senteurs du Ciel"
        description="Alle informatie over de eigenaar achter Braque Français Type Pyrénées jachthondenkennel Senteurs du Ciel."
        type="article" />
      <IndexNavbar />
      <div className="wrapper">
        <OverOnsHeader />
        <Container>
          <div className="section-story-overview">
            <Row>
              <Col className="ml-auto mr-auto text-center" md="8">
                <h2 className="title">Steve</h2>
              </Col>
            </Row>
          </div>
          <Row>
            <Col className="ml-auto mr-auto text-center" md="10">
              <img
                alt="Steve met Juno, de stammoeder waar het allemaal mee begon"
                src={require("assets/img/over-ons-2.webp")}
              ></img>
            </Col>
          </Row>
          <div className="section-story-overview">
            <Row>
              <Col className="ml-auto mr-auto text-center" md="8">
                <p>Ik ben bijna even energiek als mijn jachthonden en zorg er dan ook voor dat
                  ze dagelijks hun energie kwijt geraken. Dat betekent veel wandelen in de Herentalse bossen tijdens de
                  week terwijl er in het weekend vaak op verplaatsing gewandeld wordt langsheen de kust, langs velden, …</p>
                <p>Daarnaast ontferm ik mij natuurlijk ook over de opvoeding en de training van de honden. Onder de opvoeding verstaan we
                  alles wat nodig is om van de hond een aangename levensgezel te maken die zich zowel binnen- als buitenshuis gedraagt.
                  Onder de training verstaan we in eerste instantie de elementaire gehoorzaamheid gevolgd door een doorgedreven jachttraining.</p>
                <p>Daarnaast ben ik ook competitief ingesteld en neem ik dus ook met de honden deel aan wedstrijden.
                  Ik heb daarbij een voorkeur voor de veldwedstrijden en spendeer zeer veel tijd, kilometers en ja ook bloed,
                  zweet en de occasionele traan aan het trainen van mijn honden door ze zoveel mogelijk onder wild te brengen.
                  Veerwild is tenslotte de leraar, de hond de leerling en het baasje gewoon een trotse “papa” die vanop een
                  afstand toekijkt en de hond aanmoedigt (ok, er komt wel net iets meer bij kijken dan enkel toekijken maar het
                  blijft een feit dat het de vogel is die de hond de elementaire regels van het spelletje met de wind aanleert).</p>
                <p>Ook naar hondenshows wordt er periodiek getrokken: als fokker is het tenslotte belangrijk om de bouw van je
                  hond objectief en bij voorkeur door meerdere mensen met kennis van zake te laten beoordelen.  Een correcte bouw en
                  een uiterlijk conform de rasstandaard zijn tenslotte ook belangrijk om in het veld en op de jacht goed te kunnen presteren.</p>
              </Col>
            </Row>
          </div>

        </Container>
        <DarkFooter />
      </div>
    </>
  );
}

export default OverOns;
